import { api } from "./api";

export const postLogin = async (login: any) => {
  try {
    const response = await api.post(`Autenticacao/login/`, login);
    return response;
  } catch (error) {
    throw error;
  }
};

